<template>
  <div id="app">
    <marquee_text style="display: none;"/>
    <br/>
    <img style="display: none;" alt="Vue logo" src="./assets/logo.png">
          <router-view></router-view>
          <Feedback_Btn/>
          <br/><br/>
          <Profile_Showcase/>
      <br/> 
      <br/>
      <br/>
  </div>
</template>

<script>
 import Feedback_Btn from './components/feedback_btn.vue';
 import Profile_Showcase from './components/profile_showcase.vue';
 import marquee_text from './components/marquee_text.vue';
 import './styles_inputs_and_buttons.css';
 import './styles_forms.css';
 import './styles_global.css';

export default {
  name: 'April-8',
  components: {
    Feedback_Btn,
    Profile_Showcase,
    marquee_text
    //TopNav
  }
}
</script>



<style>
/* Import Material Design icons CSS */
@import '~@mdi/font/css/materialdesignicons.min.css';

#app {
  text-align: center;
  overflow-x: hidden;
  width: 95%;
  margin-left: auto;
  margin-right: auto;
}


.main-body-content{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  margin-left: auto;
  margin-right: auto;

}



*{
  padding: 0;
  margin: 0;
}

@import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400..900&display=swap');

/* Apply fonts */
* {
  font-family: "Orbitron", var(--fallback-fonts);
}


body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0;
  background-color: #f3f3f3;
  overflow-x: hidden;	
  background: linear-gradient(109.8deg, rgb(62, 5, 116) -5.2%, rgb(41, 14, 151) -5.2%, rgb(216, 68, 148) 103.3%);
}




/* Define fallback fonts */
:root {
  --fallback-fonts: Arial, sans-serif,
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;

  --primary: blueviolet;
  --primary-dark: rgb(39, 3, 74);
  --secondary: #4CAF50;
  --secondary-dark: #009060;
  --accent: rgba(62, 5, 116, 0.2);
  --neutral: #3d4451;
  --base-100: #ffffff;
  --base-200: #f5f6f8;
  --base-230: #f0f0f0;
  /*
  --base-200: #f4f4f6;
  */
  --base-250: #e9eaee;
  --base-280: #e0e0e0;
  --base-300: #000000;
  --base-330: #474747;
  --base-400: #ffffff;
  --contrast: #808080;
  --contrast_light: #BEBEBE;
  --contrast_light: rgb(190, 190, 190);
  --rating_star: #ffc13b;
  --online-green: #00cc44;
  --Gradient:   linear-gradient(109.8deg, rgb(62, 5, 116) -5.2%, rgb(41, 14, 151) -5.2%, rgb(216, 68, 148) 103.3%);
  --Gradient_2: linear-gradient(to right, #434343 0%, black 100%);
  --Gradient_3: linear-gradient(179.1deg, rgb(43, 170, 96) 2.3%, rgb(129, 204, 104) 98.3%);


  --font-size-small: 14px;
  --font-size-medium: 17px;
  --font-size-large: 22px;
  --font-size-extra-large: 34px;
  --font-size-top: 24px;

  --border-radius-main: 18px;
  --border-radius-main-2x: 26px;
  --border-radius-main-3x: 32px;

  --spacing-main-2x: 25px;
  --spacing-main: 20px;
  --spacing-main-mid: 15px;
  --spacing-main-half: 10px;
  --spacing-main-half-half: 5px;
  --spacing-main-half-half-half: 2.5px;

  --box-shadow-1: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  --box-shadow-2: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  --box-shadow-2: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  --box-shadow-3:  rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
  --box-shadow-4:  rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;

  --main_width: 100%; 
  --main_width_fixed: 90%; 

  --info-accent: rgba(15, 175, 255, 0.2);
  --info-accent-boxshadow: rgba(15, 175, 255, 0.5) 0px 0px 0px 1px;

  --error-accent: rgba(255, 0, 0, 0.1);
  --error-accent-boxshadow: rgba(255, 0, 0, 0.5) 0px 0px 0px 1px;

  --warning-accent: rgba(255, 255, 0, 0.2);
  --warning-accent-boxshadow: rgba(255, 255, 0, 0.5) 0px 0px 0px 1px;
  
  --success-accent: rgba(42, 210, 9, 0.1);
  --success-accent-boxshadow: rgba(42, 210, 9, 0.5) 0px 0px 0px 1px;

}

















</style>
